import { render, staticRenderFns } from "./CourseChatbox.vue?vue&type=template&id=f224e972&scoped=true&"
import script from "./CourseChatbox.vue?vue&type=script&lang=js&"
export * from "./CourseChatbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f224e972",
  null
  
)

export default component.exports